export const BIDS_TAB = {
    CONTRACT_BIDS: 1,
    MY_ACTIVE_CONTRACT_BIDS: 2,
    ARCHIVED_CONTRACT_BIDS: 3
};
